import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { IFunnelFlowResponse } from 'src/app/domain/interfaces/funnel/interface-funnel';
import { IHeaderStyles } from 'src/app/domain/interfaces/views/interface-header-styles';
import { FunnelStep } from 'src/app/domain/models/funnel/funnel-step-enum';
import { EventEverFlowType } from 'src/app/domain/models/funnel/register-funnels/event-everflow-type-enum';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { RegisterProcessesType } from 'src/app/domain/models/funnel/register-funnels/register-processes-type-enum';
import { AlertService } from 'src/app/infraestructure/drive-adapter/alert-service/alert.service';
import { FunnelService } from 'src/app/infraestructure/drive-adapter/funnel-service/funnel.service';
import { HeaderStyleService } from 'src/app/infraestructure/services-views/header-style-service/header-style.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-secondary-brand',
  templateUrl: './header-secondary-brand.component.html',
  styleUrls: ['./header-secondary-brand.component.scss']
})
export class HeaderSecondaryBrandComponent implements OnInit {
  @Input() FunnelFlow: FunnelFlow = { UserTemporary: { addresses: [] }, Step: 0 };
  @Input() showClassVerify?: boolean = false;
  @Input() brandResources!: IBrandResources;
  @Input() headerStyles!: IHeaderStyles;
  private headerStyleServiceSubscription!: Subscription;
  public pathLogoBrand!: string;
  public customLogoFinanceify: boolean = false
  public environment = environment;

  constructor(private funnelService: FunnelService, private router: Router, private alertService: AlertService, private headerStyleService: HeaderStyleService) { }

  ngOnInit(): void {
    this.headerStyleServiceSubscription = this.headerStyleService.IsHeaderDiferentPathLogo.subscribe((x) => {
      if (this.headerStyles.class == "financeify-logo") {
        this.pathLogoBrand = this.headerStyles.logo;
        this.customLogoFinanceify = true;
      }
      else if (x) {
        this.pathLogoBrand = this.environment.assetsURL + this.brandResources.pathLogoBlack!; 
      } else {
        this.pathLogoBrand = this.environment.assetsURL + this.brandResources.pathLogoWhite!;
      }
    })
  }
  GoToLogin() {
    this.funnelService.ClearUserRegister();
    window.location.href = this.brandResources.loginURL!;
  }

  ngOnDestroy(): void {
    this.headerStyleServiceSubscription?.unsubscribe();
  }

  GoToRegisterForm() {
    if (!this.FunnelFlow) { this.router.navigate(["/"]); return; }
    this.FunnelFlow.UserTemporary = {};
    this.FunnelFlow.UserInfoSent = [];
    this.FunnelFlow.RegisterProcesses = [];
    this.FunnelFlow.FunnelMessage = {
      ValidatedEmails: [],
      CreditCardAttempts: []
    }
    this.FunnelFlow.UserEverflowEvent!.EverflowEventId = EventEverFlowType.Event1;
    this.FunnelFlow.RegisterProcesses = [RegisterProcessesType.SendEverflowEvent];

    this.funnelService.SendRegisterForm(this.FunnelFlow ?? {}, FunnelStep.Step1).pipe(first()).subscribe({
      next: (funnelFlowResponse: IFunnelFlowResponse) => {
        this.alertService.setLoading(false);
      },
      error: (error: any) => {
        this.alertService.setLoading(false);
        this.FunnelFlow!.FunnelMessage!.Code = error;
        this.funnelService.ValidateFunnelMessage(this.FunnelFlow);
      }
    });
  }
}
